import axios from "config/@axios";

export const FETCH_SINGLE_ARCHIVE = "singleArchiveActions::fetchSingleArchive";
export const FETCH_SINGLE_ARCHIVE_SUCCESS =
  "singleArchiveActions::fetchSingleArchiveSuccess";
export const FETCH_SINGLE_ARCHIVE_FAILED =
  "singleArchiveActions::fetchSingleArchiveFailed";

export const fetchSingleArchive = (id, domain, silent = false) => (
  dispatch,
  getStore
) => {
  const state = getStore();
  const delete_status = state.archive.searchParams?.delete_status || "0";

  dispatch({
    type: FETCH_SINGLE_ARCHIVE,
    payload: {
      id,
      silent
    }
  });

  return axios
    .get(`archives/messages/${domain}/${id}`, { params: { delete_status } })
    .then(response => {
      dispatch({
        type: FETCH_SINGLE_ARCHIVE_SUCCESS,
        payload: {
          id,
          singleArchive: response.data
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_SINGLE_ARCHIVE_FAILED,
        payload: {
          id,
          errorText: err.errorMessage
        }
      });
    });
};
